import React from "react";
import { Controller } from "react-hook-form";
import styled from "styled-components";

import { Checkbox } from "@mui/material";

import { FormInputProps } from "./types";

export const FormCheckbox = ({ name, control, rules }: FormInputProps) => {
  return (
    <CheckboxWrapper>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, value },
          fieldState: { error },
          formState,
        }) => (
          <Checkbox
            value={value}
            checked={value}
            onChange={onChange}
            sx={{
              width: "fit-content",
              color: "var(--color-gray-600)",
              "&:hover": {
                color: "var(--color-gray-700)",
              },
              "&.Mui-checked": {
                "&:hover": {
                  color: "var(--color-primary)",
                },
              },
            }}
          />
        )}
      />
    </CheckboxWrapper>
  );
};

const CheckboxWrapper = styled.div`
  position: relative;
  align-items: center;
  margin: 0px 8px 0px 8px;
  min-width: 120px;
  width: 100%;
`;
